<div class="container">
  <nav class="row fixed-top dateretrievedstyle">
    @if (totalSuccessCount > 0 || totalFailCount > 0) {
      <div
        class="alert alert-info"
        >
        @if (totalSuccessCount > 0) {
          <strong
            >{{ totalSuccessCount }} Observation(s) submitted Successfully.
          </strong>
        }
        @if (totalFailCount > 0) {
          <strong
            >{{ totalFailCount }} Observation(s) failed to Submit
          </strong>
        }
      </div>
    }
    <div class="col-md-6 date-label">
      <strong>Date Range</strong>: {{ startDate | date : "MM/dd/yyyy" }} &rarr; {{ endDate | date : "MM/dd/yyyy" }}
    </div>
  </nav>

  <div class="fixed_header">
    <table
      matSort
      (matSortChange)="sortHeader($event)"
      matSortDisableClear="true"
      class="table table-striped margintop20"
      >
      <thead>
        <tr>
          <th mat-sort-header="name">Name</th>
          <th>Value</th>
          <th mat-sort-header="time">Effective Time</th>
          <th>
            <input
              type="checkbox"
              [(ngModel)]="isAllSelected"
              (ngModelChange)="selectAll()"
              [disabled]="isAlldisabled"
              />
          </th>
        </tr>
      </thead>
      <tbody>
        @for (entry of categoryData; track entry) {
          <tr [style.fontWeight]="entry.state" class="fontDMSans">
            <td>
              {{ entry?.resource?.code?.text }}
            </td>
            <td>
              <span>{{ getNodeValue($safeNavigationMigration(entry?.resource)) }}</span>
              <span>{{ getComponentValue($safeNavigationMigration(entry?.resource?.component)) }}</span>
            </td>
            <td>
              {{ entry?.resource?.effectiveDateTime }}
            </td>
            <td>
              <input
                type="checkbox"
                [(ngModel)]="entry.selected"
                (ngModelChange)="toggleOption()"
                [disabled]="entry.state == 'lighter'"
                />
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="row top-buffer float-end">
  <button
    type="button"
    class="btn btn-primary submit-btn"
    (click)="submitToCibmtr()"
    enabled
    >
    Submit to CIBMTR
  </button>
</div>
